import { IObjectKeys } from "src/app/modules/home/types";
import atticCeilingOneImg from "src/assets/knaufs/attic_D112-2XDF-15-EI60.jpg";
import atticCeilingTwoImg from "src/assets/knaufs/attic_D612-2X15-DF-REI60.jpg";
import atticFloorImg from "src/assets/knaufs/attic_F191.jpg";
import basementWallImg from "src/assets/knaufs/basement_W112-DF-13-EI90.jpg";
import bathroomUpWallOneImg from "src/assets/knaufs/bathroom-Up_AQP-INDOOR-OBLOGA-2X-12,5-MM.jpg";
import bathroomUpWallTwoImg from "src/assets/knaufs/bathroom-Up_AQP-INDOOR-ZID-12,5-CM.jpg";
import bathroomUpCeilingImg from "src/assets/knaufs/bathroom-Up_D112H213.jpg";
import bathroomUpWallThreeImg from "src/assets/knaufs/bathroom-Up_W113EI90.jpg";
import bathroomMidWallImg from "src/assets/knaufs/bathroom-mid_Knauf_W112-H2-A13.jpg";
import bedroomWallImg from "src/assets/knaufs/bedroomW112-A13-EI60 .jpg";
import hallwayMidWallImg from "src/assets/knaufs/hallway-Mid_Knauf_W112H213EI60_M.jpg";
import hallwayUpWallImg from "src/assets/knaufs/hallway-Up_W628-TIP-BEI90.jpg";
import kidsRoomCeilingImg from "src/assets/knaufs/kids-Room_D112-A13-SP.STROP.jpg";
import kitchenCeilingImg from "src/assets/knaufs/kitchen_D112-2X20-MBP-EI90.jpg";
import kitchenWallImg from "src/assets/knaufs/kitchen_W112-DIAMANT-EI90.jpg";
import livingRoomWallImg from "src/assets/knaufs/living-Room_W623-OBLOGA-CD-PROFILI.jpg";
import musicRoomWallImg from "src/assets/knaufs/music-Room_W112-SILENTBOARD.jpg";
import officeFloorImg from "src/assets/knaufs/office_F145.jpg";
import officeWallImg from "src/assets/knaufs/office_W113EI90.jpg";
import ordinacijaOfficeCeilingImg from "src/assets/knaufs/ordinacija-Office_D127-Cleaneo.jpg";
import ordinacijaOfficeWallImg from "src/assets/knaufs/ordinacija-Office_W629-C-CLEANEO-obloga-CW.jpg";
import ordinacijaWallOneImg from "src/assets/knaufs/ordinacija_W112-SAFEBOARD.jpg";
import ordinacijaWallTwoImg from "src/assets/knaufs/ordinacija_W626-DIAMANT-2X12,5.jpg";
import outsideRightWallImg from "src/assets/knaufs/outside-Right_KFS_WARM_WAND_MW_EPS.jpg";
import outsideCeilingImg from "src/assets/knaufs/outside_AQP-OUTDOOR-12,5-MM-SPSTROP.jpg";
import atticImg from "src/assets/rooms/attic.jpg";
import basementImg from "src/assets/rooms/basement.jpg";
import bathromMidImg from "src/assets/rooms/bathroom-mid.jpg";
import bathroomUpImg from "src/assets/rooms/bathroom-up.jpg";
import bedroomImg from "src/assets/rooms/bedroom.jpg";
import hallwayMidImg from "src/assets/rooms/hallway-mid.jpg";
import hallwayUpImg from "src/assets/rooms/hallway-up.jpg";
import introImg from "src/assets/rooms/intro.jpg";
import kidsRoomImg from "src/assets/rooms/kids-room.jpg";
import kitchenImg from "src/assets/rooms/kitchen.jpg";
import livingRoomImg from "src/assets/rooms/living-room.jpg";
import musicRoomImg from "src/assets/rooms/music-room.jpg";
import officeImg from "src/assets/rooms/office.jpg";
import ordinacijaOfficeImg from "src/assets/rooms/ordinacija-office.jpg";
import ordinacijaImg from "src/assets/rooms/ordinacija.jpg";
import outsideRightImg from "src/assets/rooms/outside-right.jpg";
import outsideImg from "src/assets/rooms/outside.jpg";
import startingImg from "src/assets/rooms/starting-image.jpg";
import waitingRoomStudioImg from "src/assets/rooms/waiting-room,-studio.jpg";
import waitingRoomImg from "src/assets/rooms/waiting-room.jpg";
import atticVideoReverse from "src/assets/videos/attic-reverse.mp4";
import atticVideo from "src/assets/videos/attic.mp4";
import basementVideoReverse from "src/assets/videos/basement-reverse.mp4";
import basementVideo from "src/assets/videos/basement.mp4";
import bathroomMidVideoReverse from "src/assets/videos/bathroom-mid-reverse.mp4";
import bathroomMidVideo from "src/assets/videos/bathroom-mid.mp4";
import bathroomUpVideoReverse from "src/assets/videos/bathroom-up-reverse.mp4";
import bathroomUpVideo from "src/assets/videos/bathroom-up.mp4";
import bedroomVideoReverse from "src/assets/videos/bedroom-reverse.mp4";
import bedroomVideo from "src/assets/videos/bedroom.mp4";
import hallwayMidVideoReverse from "src/assets/videos/hallway-mid-reverse.mp4";
import hallwayMidVideo from "src/assets/videos/hallway-mid.mp4";
import hallwayUpVideoReverse from "src/assets/videos/hallway-up-reverse.mp4";
import hallwayUpVideo from "src/assets/videos/hallway-up.mp4";
import kidsRoomVideoReverse from "src/assets/videos/kids-room-reverse.mp4";
import kidsRoomVideo from "src/assets/videos/kids-room.mp4";
import kitchenVideoReverse from "src/assets/videos/kitchen-reverse.mp4";
import kitchenVideo from "src/assets/videos/kitchen.mp4";
import livingRoomVideoReverse from "src/assets/videos/living-room-reverse.mp4";
import livingRoomVideo from "src/assets/videos/living-room.mp4";
import musicRoomVideoReverse from "src/assets/videos/music-room-reverse.mp4";
import musicRoomVideo from "src/assets/videos/music-room.mp4";
import officeVideoReverse from "src/assets/videos/office-reverse.mp4";
import officeVideo from "src/assets/videos/office.mp4";
import ordinacijaOfficeVideoReverse from "src/assets/videos/ordinacija-office-reverse.mp4";
import ordinacijaOfficeVideo from "src/assets/videos/ordinacija-office.mp4";
import ordinacijaVideoReverse from "src/assets/videos/ordinacija-reverse.mp4";
import ordinacijaVideo from "src/assets/videos/ordinacija.mp4";
import outsideVideoReverse from "src/assets/videos/outside-reverse.mp4";
import outsideRightVideoReverse from "src/assets/videos/outside-right-reverse.mp4";
import outsideRightVideo from "src/assets/videos/outside-right.mp4";
import outsideVideo from "src/assets/videos/outside.mp4";
import startingVideoReverse from "src/assets/videos/starting-reverse.mp4";
import startingVideo from "src/assets/videos/starting.mp4";
import waitingRoomVideoReverse from "src/assets/videos/waiting-room-reverse.mp4";
import waitingRoomStudioVideoReverse from "src/assets/videos/waiting-room-studio-reverse.mp4";
import waitingRoomStudioVideo from "src/assets/videos/waiting-room-studio.mp4";
import waitingRoomVideo from "src/assets/videos/waiting-room.mp4";

import homeCSS from "./Home.module.css";

export const ROOM_TYPES = {
  INTRO: "intro",
  STARTING: "starting",
  ATTIC: "attic",
  BASEMENT: "basement",
  BATHROOM_MID: "bathroomMid",
  BATHROOM_UP: "bathroomUp",
  BEDROOM: "bedroom",
  HALLWAY_MID: "hallwayMid",
  HALLWAY_UP: "hallwayUp",
  KIDS_ROOM: "kidsRoom",
  KITCHEN: "kitchen",
  LIVING_ROOM: "livingRoom",
  MUSIC_ROOM: "musicRoom",
  OFFICE: "office",
  ORDINACIJA_OFFICE: "ordinacijaOffice",
  ORDINACIJA: "ordinacija",
  OUTSIDE_RIGHT: "outsideRight",
  OUTSIDE: "outside",
  WAITING_ROOM_STUDIO: "waitingRoomStudio",
  WAITING_ROOM: "waitingRoom",
};

export const SYSTEM_GROUP: IObjectKeys = {
  wall: {
    id: 1,
    type: "wall",
    value: "sustavi zidova",
  },
  wall_cover: {
    id: 2,
    type: "wall cover",
    value: "sustavi zidnih obloga i šahti",
  },
  suspended_ceiling: {
    id: 3,
    type: "suspended ceiling",
    value: "sustavi spuštenih stropova",
  },
  fire_protection: {
    id: 4,
    type: "fire protection",
    value: "posebni protupožarni sustavi",
  },
  aquapanel: {
    id: 5,
    type: "aquapanel",
    value: "aquapanel sustavi",
  },
  floor: {
    id: 6,
    type: "floor",
    value: "sustavi podova",
  },
  facade: {
    id: 7,
    type: "facade",
    value: "fasadni sustavi",
  },
  plaster: {
    id: 8,
    type: "plaster",
    value: "sustavi gipsanih žbuka",
  },
};

export const BASE_SYSTEMS = [
  {
    sysGroupId: SYSTEM_GROUP.wall.id,
    id: 1,
    baseSystemId: 1,
    name: "W112 A13 EI60",
    tooltip: "Pregradni zid iz standardnih gipsanih ploča - jednostruka potkonstrukcija.\n\nPROTUPOŽARNI ZAHTJEVI DO 60 MIN, STANDARDNA RAZINA ZVUČNE ZAŠTITE.",
    calculationDescription: "W112 A13 EI60 pregradni zid",
    group: "W112",
    class: homeCSS.bedroomWall,
    imageSource: bedroomWallImg,
  },
  {
    sysGroupId: SYSTEM_GROUP.wall.id,
    id: 4,
    baseSystemId: 2,
    name: "W112 H2+A13",
    calculationDescription: "W112 H2 i A13 pregradni zid",
    tooltip:
      "Pregradni zid iz impregniranih i standardnih gipsanih ploča - jednostruka potkonstrukcija.\n\nZAŠTITA OD VLAGE, PROTUPOŽARNI ZAHTJEVI DO 60 MIN, STANDARDNA RAZINA ZVUČNE ZAŠTITE.",
    group: "W112",
    class: homeCSS.bathroomMidWall,
    imageSource: bathroomMidWallImg,
  },
  {
    sysGroupId: SYSTEM_GROUP.wall.id,
    id: 7,
    baseSystemId: 3,
    name: "W112 DF 13 EI90",
    calculationDescription: "W112 DF 13 EI90 pregradni zid",
    tooltip: "Pregradni zid iz protupožarnih gipsanih ploča - jednostruka potkonstrukcija.\n\nPROTUPOŽARNI ZAHTJEVI DO 90 MIN, VEĆA RAZINA ZVUČNE ZAŠTITE.",
    group: "W112",
    class: homeCSS.basementWall,
    imageSource: basementWallImg,
  },
  {
    sysGroupId: SYSTEM_GROUP.wall.id,
    id: 10,
    baseSystemId: 4,
    name: "W112 H2 13 EI60",
    calculationDescription: "W112 H2 13 EI60 pregradni zid",
    tooltip:
      "Pregradni zid iz impregniranih gipsanih ploča - jednostruka potkonstrukcija.\n\nZAŠTITA OD VLAGE, PROTUPOŽARNI ZAHTJEVI DO 60 MIN, STANDARDNA RAZINA ZVUČNE ZAŠTITE.",
    group: "W112",
    class: homeCSS.hallwayMidWall,
    imageSource: hallwayMidWallImg,
  },
  {
    sysGroupId: SYSTEM_GROUP.wall.id,
    id: 13,
    baseSystemId: 5,
    name: "W112 DIAMANT EI90",
    calculationDescription: "W112 DIAMANT EI90 pregradni zid",
    tooltip:
      "Pregradni zid iz Diamant gipsanih ploča - jednostruka potkonstrukcija.\n\nZAŠTITA OD VLAGE, PROTUPOŽARNI ZAHTJEVI DO 90 MIN, POVEĆANA MEHANIČKA OTPORNOST, VRLO VISOKA RAZINA ZVUČNE ZAŠTITE, PROTUBALISTIČKI SUSTAVI.",
    group: "W112",
    class: homeCSS.kitchenWall,
    imageSource: kitchenWallImg,
  },
  {
    sysGroupId: SYSTEM_GROUP.wall.id,
    id: 16,
    baseSystemId: 6,
    name: "W112 SILENTBOARD",
    calculationDescription: "W112 SILENTBOARD pregradni zid",
    tooltip: "Pregradni zid iz Silentboard gipsanih ploča - jednostruka potkonstrukcija.\n\nPROTUPOŽARNI ZAHTJEVI DO 90 MIN, NAJVIŠA RAZINA ZVUČNE ZAŠTITE.",
    group: "W112",
    class: homeCSS.musicRoomWall,
    imageSource: musicRoomWallImg,
  },
  {
    sysGroupId: SYSTEM_GROUP.wall.id,
    id: 17,
    baseSystemId: 7,
    name: "W113 EI90",
    calculationDescription: "W113 EI90 pregradni zid",
    tooltip:
      "Pregradni zid iz Diamant gipsanih ploča - jednostruka potkonstrukcija.\n\nZAŠTITA OD VLAGE, PROTUPOŽARNI ZAHTJEVI DO 120 MIN, POVEĆANA MEHANIČKA OTPORNOST, VRLO VISOKA RAZINA ZVUČNE ZAŠTITE.",
    group: "W113",
    class: homeCSS.bathroomUpWallThree,
    imageSource: bathroomUpWallThreeImg,
  },
  {
    sysGroupId: SYSTEM_GROUP.wall.id,
    id: 20,
    baseSystemId: 8,
    name: "W115 EI90",
    calculationDescription: "W115  EI90 pregradni zid (Rw 65 dB)",
    tooltip: "Pregradni zid iz standardnih gipsanih ploča - dvostruka potkonstrukcija.\n\nPROTUPOŽARNI ZAHTJEVI DO 60 MIN, VEĆE RAZINE ZVUČNE ZAŠTITE.",
    class: homeCSS.unassignedSubSystem,
    imageSource: "",
  },
  {
    sysGroupId: SYSTEM_GROUP.wall.id,
    id: 21,
    baseSystemId: 9,
    name: "W116",
    calculationDescription: "W116 pregradni zid (Rw 54 dB)",
    tooltip:
      "Pregradni zid iz impregniranih gipsanih ploča - dvostruka potkonstrukcija.\n\nZAŠTITA OD VLAGE, PROTUPOŽARNI ZAHTJEVI DO 60 MIN, STANDARDNA RAZINA ZVUČNE ZAŠTITE.",
    class: homeCSS.unassignedSubSystem,
    imageSource: "",
  },
  {
    sysGroupId: SYSTEM_GROUP.wall.id,
    id: 22,
    baseSystemId: 10,
    name: "W118 RC3 PROTUPROVALNI ZID",
    calculationDescription: "W118 RC3 protuprovalni zid (Rw 65 dB)",
    tooltip:
      "Protuprovalni zid iz Diamant gipsanih ploča - jednostruka potkonstrukcija.\n\nPROTUPROVALNOST, ZAŠTITA OD VLAGE, PROTUPOŽARNI ZAHTJEVI DO 90 MIN, VRLO VISOKA RAZINA ZVUČNE ZAŠTITE, POVEĆANA MEHANIČKA OTPORNOST.",
    class: homeCSS.unassignedSubSystem,
    imageSource: "",
  },
  {
    sysGroupId: SYSTEM_GROUP.wall.id,
    id: 23,
    baseSystemId: 11,
    name: "K131 Pb 1 mm",
    calculationDescription: "K 131 Pb 1 mm pregradni zid za zaštitu od zračenja",
    tooltip: "Pregradni zid iz olovnih ploča za područje rendgenske dijagnostike.\n\nZAŠTITA OD ZRAČENJA.",
    class: homeCSS.unassignedSubSystem,
    imageSource: "",
  },
  {
    sysGroupId: SYSTEM_GROUP.wall.id,
    id: 24,
    baseSystemId: 12,
    name: "SAFEBOARD 12,5 cm 1+1",
    calculationDescription: "W112 SAFEBOARD 1x12,5 mm, DIAMANT 1x12,5 mm",
    tooltip:
      "Pregradni zid iz Safeboard i Diamant gipsanih ploča - bez olovnog lima.\n\nEKONOMIČNA ZAŠTITA OD ZRAČENJA, PROTUPOŽARNI ZAHTJEVI, VRLO VISOKA RAZINA ZVUČNE ZAŠTITE.",
    class: homeCSS.ordinacijaWallOne,
    imageSource: ordinacijaWallOneImg,
  },
  {
    sysGroupId: SYSTEM_GROUP.wall.id,
    id: 25,
    baseSystemId: 13,
    name: "W131",
    calculationDescription: "W131 EI-M 90 pregradni zid",
    tooltip:
      "Pregradni zid iz protupožarnih gipsanih ploča sa slojem pocinčanog lima - jednostruka potkonstrukcija.\n\nPROTUPOŽARNI ZAHTJEVI DO 90 MIN, VEĆA RAZINA ZVUČNE ZAŠTITE.",
    class: homeCSS.unassignedSubSystem,
    imageSource: "",
  },
  {
    sysGroupId: SYSTEM_GROUP.wall_cover.id,
    id: 26,
    baseSystemId: 14,
    name: "W611 SUHA ŽBUKA",
    calculationDescription: "W611 suha žbuka",
    tooltip: "Suha žbuka alternativa je mokroj žbuci, bez dodatne građevinske vlage na stabilnoj podlozi.",
    class: homeCSS.unassignedSubSystem,
    imageSource: "",
  },
  {
    sysGroupId: SYSTEM_GROUP.wall_cover.id,
    id: 28,
    baseSystemId: 15,
    name: "W623 OBLOGA CD PROFILI",
    calculationDescription: "W623 zidna obloga CD profili",
    tooltip:
      "Zidna obloga iz UD/CD profila - jednoslojna ili dvoslojna.\n\nIZRAVNO PRIČVRŠĆENA NA POSTOJEĆI ZID, VISINA ZIDA DO 10 m, POBOLJŠANA ZVUČNA IZOLACIJA.",
    group: "W623",
    class: homeCSS.livingRoomWall,
    imageSource: livingRoomWallImg,
  },
  {
    sysGroupId: SYSTEM_GROUP.wall_cover.id,
    id: 30,
    baseSystemId: 16,
    name: "W625",
    calculationDescription: "W625 zidna obloga bez protupožarnih zahtjeva",
    tooltip:
      "Zidna obloga iz UW/CW profila - jednoslojna.\n\nSAMOSTOJEĆA, VISINA ZIDNE OBLOGE DO 5,90 m, POBOLJŠANA ZVUČNA IZOLACIJA, BEZ PROTUPOŽARNIH ZAHTJEVA.",
    class: homeCSS.unassignedSubSystem,
    imageSource: "",
  },
  {
    sysGroupId: SYSTEM_GROUP.wall_cover.id,
    id: 32,
    baseSystemId: 17,
    name: "W626 A13,H213",
    calculationDescription: "W 626 zidna obloga bez protupožarnih zahtjeva",
    tooltip:
      "Zidna obloga iz UW/CW profila - dvoslojna obloga.\n\nSAMOSTOJEĆA, VISINA ZIDNE OBLOGE DO 7,80 m, IZRAZITO POBOLJŠANA ZVUČNA IZOLACIJA, BEZ PROTUPOŽARNIH ZAHTJEVA, OTPORNOST NA UDARAC LOPTOM.",
    class: homeCSS.unassignedSubSystem,
    imageSource: "",
  },
  {
    sysGroupId: SYSTEM_GROUP.wall_cover.id,
    id: 34,
    baseSystemId: 18,
    name: "W626 DIAMANT 2x12,5",
    calculationDescription: "W626 DIAMANT ploča DFH2IR 2x12,5 zidna obloga",
    tooltip:
      "Zidna obloga iz UW/CW profila i Diamant gipsanih ploča - dvoslojna obloga.\n\nSAMOSTOJEĆA, VISINA ZIDNE OBLOGE DO 7,80 m, IZRAZITO POBOLJŠANA ZVUČNA IZOLACIJA, OTPORNOST NA UDARAC LOPTOM, PROTUPOŽARNI ZAHTJEVI DO 90 MIN.",
    group: "W626",
    class: homeCSS.ordinacijaWallTwo,
    imageSource: ordinacijaWallTwoImg,
  },
  {
    sysGroupId: SYSTEM_GROUP.wall_cover.id,
    id: 35,
    baseSystemId: 19,
    name: "W628 tip B EI60",
    calculationDescription: "W628 tip B EI60 pregrada za šahte",
    tooltip:
      "Obloga za šahte iz UW/CW profila i protupožarnih ploča - dvoslojna ili troslojna obloga.\n\nSAMOSTOJEĆA, VISINA ZIDNE OBLOGE DO 6,00 m, POBOLJŠANA ZVUČNA IZOLACIJA, OTPORNOST NA UDARAC LOPTOM, PROTUPOŽARNI ZAHTJEVI DO 120 MIN.",
    class: homeCSS.unassignedSubSystem,
    imageSource: "",
  },
  {
    sysGroupId: SYSTEM_GROUP.wall_cover.id,
    id: 36,
    baseSystemId: 20,
    name: "W628 TIP B EI90",
    calculationDescription: "W628 tip B EI90 pregrade za šahte",
    tooltip:
      "Obloga za šahte iz UW/CW profila i protupožarnih ploča - dvoslojna ili troslojna obloga.\n\nSAMOSTOJEĆA, VISINA ZIDNE OBLOGE DO 6,00 m, POBOLJŠANA ZVUČNA IZOLACIJA, OTPORNOST NA UDARAC LOPTOM, PROTUPOŽARNI ZAHTJEVI DO 120 MIN.",
    group: "W628",
    class: homeCSS.hallwayUpWall,
    imageSource: hallwayUpWallImg,
  },
  {
    sysGroupId: SYSTEM_GROUP.wall_cover.id,
    id: 37,
    baseSystemId: 21,
    name: "W629 CLEANEO OBLOGA CW PROFILI",
    calculationDescription: "W629 Cleaneo zidna obloga s dvostrukim CW profilima",
    tooltip:
      "Zidna obloga iz CW profila, Cleaneo akustičnih i Diamant gipsanih ploča u zoni parapeta.\n\nSAMOSTOJEĆA, RAZMAK PROFILA DO 312,5 mm, VISINA ZIDNE OBLOGE DO 6,60 m, ZAHTJEVI AKUSTIKE, OTPORNOST NA UDARAC LOPTOM, PROTUPOŽARNI ZAHTJEVI DO 90 MIN.",
    group: "W629",
    class: homeCSS.ordinacijaOfficeWall,
    imageSource: ordinacijaOfficeWallImg,
  },
  {
    sysGroupId: SYSTEM_GROUP.wall_cover.id,
    id: 38,
    baseSystemId: 22,
    name: "K151 Pb 1 mm",
    calculationDescription: "K151 zidna obloga s olovom za zaštitu od zračenja",
    tooltip: "Zidna obloga iz olovnih ploča za područje rendgenske dijagnostike.\n\nZAŠTITA OD ZRAČENJA.",
    class: homeCSS.unassignedSubSystem,
    imageSource: "",
  },
  {
    sysGroupId: SYSTEM_GROUP.suspended_ceiling.id,
    id: 40,
    baseSystemId: 23,
    name: "D112 A13",
    calculationDescription: "D112 A13 spušteni strop bez protupožarnih zahtjeva",
    tooltip: "Spušteni strop od ovjesa, metalne potkonstrukcije i 1 standardne gipsane ploče bez značajnijih građevinsko - fizikalnih zahtjeva.",
    group: "D112",
    class: homeCSS.kidsRoomCeiling,
    imageSource: kidsRoomCeilingImg,
  },
  {
    sysGroupId: SYSTEM_GROUP.suspended_ceiling.id,
    id: 41,
    baseSystemId: 24,
    name: "D112 H2 13",
    calculationDescription: "D112 H2 13 spušteni strop bez protupožarnih zahtjeva",
    tooltip: "Spušteni strop od ovjesa, metalne potkonstrukcije i 1 impregnirane gipsane ploče.\n\nZAŠTITA OD VLAGE.",
    group: "D112",
    class: homeCSS.bathroomUpCeiling,
    imageSource: bathroomUpCeilingImg,
  },
  {
    sysGroupId: SYSTEM_GROUP.suspended_ceiling.id,
    id: 42,
    baseSystemId: 25,
    name: "D112 2xDF 15 EI60",
    calculationDescription: "D112 2 x DF 15 EI60 protupožarni spušteni strop odozdo",
    tooltip: "Protupožarni spušteni strop od ovjesa, metalne potkonstrukcije i 2 protupožarne gipsane ploče tip DF 15.\n\nPROTUPOŽARNI ZAHTJEVI DO 60 MIN.",
    group: "D112",
    class: homeCSS.atticCeilingOne,
    imageSource: atticCeilingOneImg,
  },
  {
    sysGroupId: SYSTEM_GROUP.suspended_ceiling.id,
    id: 43,
    baseSystemId: 26,
    name: "D113 2x12,5",
    calculationDescription: "D113 2x12,5 spušteni strop bez protupožarnih zahtjeva, konstrukcija u nivou",
    tooltip:
      "Spušteni strop od ovjesa, metalne potkonstrukcije i gipsane ploče.\n\nKONSTRUKCIJA U NIVOU, NAJMANJE VISINE SPUŠTANJA, BEZ PROTUPOŽARNIH ZAHTJEVA.",
    class: homeCSS.unassignedSubSystem,
    imageSource: "",
  },
  {
    sysGroupId: SYSTEM_GROUP.suspended_ceiling.id,
    id: 44,
    baseSystemId: 27,
    name: "D112 3x15 DF EI90",
    calculationDescription: "D112 3x15 DF EI90 protupožarni spušteni strop odozdo",
    tooltip: "Protupožarni spušteni strop od ovjesa, metalne potkonstrukcije i 3 protupožarne gipsane ploče tip DF 15.\n\nPROTUPOŽARNI ZAHTJEVI DO 90 MIN.",
    class: homeCSS.unassignedSubSystem,
    imageSource: "",
  },
  {
    sysGroupId: SYSTEM_GROUP.suspended_ceiling.id,
    id: 45,
    baseSystemId: 28,
    name: "D112 2x20 MBP EI90",
    calculationDescription: "D112 2x20 MPB EI90 protupožarni spušteni strop odozdo",
    tooltip: "Protupožarni spušteni strop od ovjesa, metalne potkonstrukcije i 2 protupožarne gipsane ploče tip DF 20.\n\nPROTUPOŽARNI ZAHTJEVI DO 90 MIN.",
    group: "D112",
    class: homeCSS.kitchenCeiling,
    imageSource: kitchenCeilingImg,
  },
  {
    sysGroupId: SYSTEM_GROUP.suspended_ceiling.id,
    id: 46,
    baseSystemId: 29,
    name: "D116 EI90",
    calculationDescription: "D116 EI90 protupožarni spušteni strop",
    tooltip:
      "Protupožarni spušteni strop od ovjesa, metalne potkonstrukcije UA50 i 2 protupožarne gipsane ploče tip DF 20.\n\nPROTUPOŽARNI ZAHTJEVI DO 90 MIN.",
    class: homeCSS.unassignedSubSystem,
    imageSource: "",
  },
  {
    sysGroupId: SYSTEM_GROUP.suspended_ceiling.id,
    id: 47,
    baseSystemId: 30,
    name: "D127 Cleaneo",
    calculationDescription: "D127 Cleaneo akustični spušteni strop bez protupožarnih zahtjeva s udjelom perforacije 23%",
    tooltip:
      "Akustični spušteni strop od ovjesa, metalne potkonstrukcije i akustičnih gipsanih ploča Cleaneo.\n\nVELIKI IZBOR RAZLIČITIH UZORAKA PERFORACIJA, AKUSTIČNA SVOJSTVA.",
    group: "D127",
    class: homeCSS.ordinacijaOfficeCeiling,
    imageSource: ordinacijaOfficeCeilingImg,
  },
  {
    sysGroupId: SYSTEM_GROUP.suspended_ceiling.id,
    id: 48,
    baseSystemId: 31,
    name: "D112 L",
    calculationDescription: "D112L 1xA13L 12,5 mm spušteni strop bez protupožarnih zahtjeva",
    tooltip: "Spušteni strop od ovjesa, metalne potkonstrukcije i 1 A13L gipsane ploče bez značajnijih građevinsko - fizikalnih zahtjeva.",
    class: homeCSS.unassignedSubSystem,
    imageSource: "",
  },
  {
    sysGroupId: SYSTEM_GROUP.suspended_ceiling.id,
    id: 49,
    baseSystemId: 32,
    name: "D612 2x15 DF REI60",
    calculationDescription: "D612 2x15 DF RE/REI60 protupožarna obloga krovnih kosina",
    tooltip:
      "Protupožarna obloga krovnih kosina kod drvenih potkrovlja od 2 protupožarne gipsane ploče tip DF 15.\n\nZAŠTITA OD POŽARA, ZVUČNA IZOLACIJA I TOPLINSKA IZOLACIJA, PROTUPOŽARNI ZAHTJEVI DO 60 MIN.",
    group: "D612",
    class: homeCSS.atticCeilingTwo,
    imageSource: atticCeilingTwoImg,
  },
  {
    sysGroupId: SYSTEM_GROUP.suspended_ceiling.id,
    id: 50,
    baseSystemId: 33,
    name: "D112 DIAMANT 2x12,5 mm EI30",
    calculationDescription: "D112 DIAMANT ploča 2x12,5 EI30 protupožarni spušteni strop",
    tooltip:
      "Spušteni strop od ovjesa, metalne potkonstrukcije i 2 Diamant gipsane ploče.\n\nPROTUPOŽARNI ZAHTJEVI DO 30 MIN, ZVUČNA ZAŠTITA I ZAŠTITA OD VLAGE.",
    class: homeCSS.unassignedSubSystem,
    imageSource: "",
  },
  {
    sysGroupId: SYSTEM_GROUP.suspended_ceiling.id,
    id: 51,
    baseSystemId: 34,
    name: "K219 EI90 O-O",
    calculationDescription: "K219 EI90 samonosivi protupožarni strop odozdo i odozgo za raspon prostorije maks. 325 cm",
    tooltip: "Samonosivi spušteni strop pričvršćen na zidove od Fireboard gipsanih ploča tip 20 mm.\n\nPROTUPOŽARNI ZAHTJEVI DO 90 MIN.",
    class: homeCSS.unassignedSubSystem,
    imageSource: "",
  },
  {
    sysGroupId: SYSTEM_GROUP.suspended_ceiling.id,
    id: 52,
    baseSystemId: 35,
    name: "K217 REI 90 2x20 FB A1",
    calculationDescription: "K217 REI90 2x20 FB A1 spuštanje do 12 cm direktni ovjes, protupožarni spušteni strop",
    tooltip: "Protupožarni spušteni strop s potkonstrukcijom od trapezastog lima kod trapezastih krovova.\n\nPROTUPOŽARNI ZAHTJEVI DO 90 MIN.",
    class: homeCSS.unassignedSubSystem,
    imageSource: "",
  },
  {
    sysGroupId: SYSTEM_GROUP.fire_protection.id,
    id: 53,
    baseSystemId: 36,
    name: "K 252",
    calculationDescription: "K 252 FIREBOARD ploča A1 R 120 obloga čeličnih greda",
    tooltip: "Protupožarna obloga čeličnih greda i stupova s Fireboard pločama.\n\nPROTUPOŽARNI ZAHTJEVI DO 180 MIN.",
    group: "K 252",
    class: homeCSS.hide,
  },
  {
    sysGroupId: SYSTEM_GROUP.fire_protection.id,
    id: 54,
    baseSystemId: 37,
    name: "W227 EI90",
    calculationDescription: "W227 EI90 obloga parapeta fasade 100 cm visine",
    tooltip: "Protupožarna obloga parapeta fasade kao zaštita od prebacivanja požara s jedne etaže na drugu.\n\nPROTUPOŽARNI ZAHTJEVI DO 120 MIN.",
    group: "W227",
    class: homeCSS.hide,
  },
  {
    sysGroupId: SYSTEM_GROUP.aquapanel.id,
    id: 55,
    baseSystemId: 38,
    name: "AQUAPANEL OUTDOOR SPUŠTENI STROP",
    calculationDescription: "AQUAPANEL Outdoor spušteni strop s antikorozivnom zaštitom",
    tooltip:
      "Vanjski spušteni strop s antikorozivnom zaštitom iz cementnih Aquapanel Outdoor ploča.\n\nOTPORNOST NA EKSTREMNE VREMENSKE UVJETE (VJETAR, SMRZAVANJE I VODOPOSTOJANOST), OTPORNOST NA GLJIVICE I PLIJESAN.",
    group: "AQP OUTDOOR",
    class: homeCSS.outsideCeiling,
    imageSource: outsideCeilingImg,
  },
  {
    sysGroupId: SYSTEM_GROUP.aquapanel.id,
    id: 57,
    baseSystemId: 39,
    name: "AQUAPANEL SKY LITE SPUŠTENI STROP",
    calculationDescription: "AQUAPANEL Sky Lite spušteni strop s antikorozivnom zaštitom",
    tooltip:
      "Vanjski i unutarnji spušteni strop s antikorozivnom zaštitom iz cementnih Aqupanel Sky Lite ploča.\n\nOTPORNOST NA EKSTREMNE VREMENSKE UVJETE (VJETAR, SMRZAVANJE I VODOPOSTOJANOST), OTPORNOST NA GLJIVICE I PLIJESAN.",
    class: homeCSS.unassignedSubSystem,
    imageSource: "",
  },
  {
    sysGroupId: SYSTEM_GROUP.aquapanel.id,
    id: 58,
    baseSystemId: 40,
    name: "AQUAPANEL INDOOR ZID",
    calculationDescription: "AQUAPANEL Indoor pregradni zid 12,5 cm s antikorozivnom zaštitom",
    tooltip: "Pregradni zid za vlažne prostore s antikorozivnom zaštitom iz cementnih Aquapanel Indoor ploča.\n\nVODOPOSTOJANOST.",
    group: "Zid",
    class: homeCSS.bathroomUpWallTwo,
    imageSource: bathroomUpWallTwoImg,
  },
  {
    sysGroupId: SYSTEM_GROUP.aquapanel.id,
    id: 59,
    baseSystemId: 41,
    name: "AQUAPANEL INDOOR OBLOGA 2x12,5 mm",
    calculationDescription: "AQUAPANEL Indoor zidna obloga 17,5 cm s antikorozivnom zaštitom",
    tooltip: "Zidna obloga za vlažne prostore s antikorozivnom zaštitom iz cementnih  Aquapanel Indoor ploča.\n\nVODOPOSTOJANOST.",
    group: "Indoor Obloga",
    class: homeCSS.bathroomUpWallOne,
    imageSource: bathroomUpWallOneImg,
  },
  {
    sysGroupId: SYSTEM_GROUP.facade.id,
    id: 63,
    baseSystemId: 45,
    name: "MW / MINERALNA KAMENA VUNA",
    calculationDescription: "KFS MW fasadni sustav s mineralnom kamenom vunom",
    tooltip: "Fasadni sustav s mineralnom kamenom vunom.\n\nTOPLINSKA IZOLACIJA, NAJVIŠI ZAHTJEVI ZA ZAŠTITU OD POŽARA I BUKE.",
    class: homeCSS.unassignedSubSystem,
    imageSource: "",
  },
  {
    sysGroupId: SYSTEM_GROUP.facade.id,
    id: 66,
    baseSystemId: 46,
    name: "EPS / STIROPOR",
    calculationDescription: "KFS EPS fasadni sustav sa stiroporom",
    tooltip: "Fasadni sustav sa stiroporom.\n\nTOPLINSKA IZOLACIJA.",
    class: homeCSS.unassignedSubSystem,
    imageSource: "",
  },
  {
    sysGroupId: SYSTEM_GROUP.facade.id,
    id: 68,
    baseSystemId: 47,
    name: "WARM WAND MW, EPS / MINERALNA KAMENA VUNA, STIROPOR",
    calculationDescription: "KFS WARM WAND MW EPS fasadni sustav s mineralnom kamenom vunom i stiroporom",
    tooltip: "Fasadni sustav s mineralnom kamenom vunom i stiroporom.",
    group: "WARM WAND MW",
    class: homeCSS.outsideRightWall,
    imageSource: outsideRightWallImg,
  },
  {
    sysGroupId: SYSTEM_GROUP.floor.id,
    id: 60,
    baseSystemId: 42,
    name: "F145",
    calculationDescription: "F145 suhi estrih",
    tooltip: "Suhi estrih iz podnih gipsanih ploča F145. Moguće je izvesti 'plivajući' ili 'izravnavajući' pod.",
    group: "F145",
    class: homeCSS.officeFloor,
    imageSource: officeFloorImg,
  },
  {
    sysGroupId: SYSTEM_GROUP.floor.id,
    id: 61,
    baseSystemId: 43,
    name: "F181",
    calculationDescription: "F181 uzdignuti pod na metalnim nožicama različitih visina",
    tooltip: "Uzdignuti pod iz gips - vlaknastih ploča F181 montiran direktno na čelične nožice - jednoslojni ili dvoslojni pod.",
    class: homeCSS.unassignedSubSystem,
    imageSource: "",
  },
  {
    sysGroupId: SYSTEM_GROUP.floor.id,
    id: 62,
    baseSystemId: 44,
    name: "F191",
    calculationDescription: "F191 uzdignuti 'plivajući' pod na drvenim, čeličnim konstrukcijama",
    tooltip: "Uzdignuti 'plivajući' pod iz gips - vlaknastih ploča F191 montiran na nosive drvene čelične konstrukcije.",
    group: "F191",
    class: homeCSS.atticFloor,
    imageSource: atticFloorImg,
  },
  {
    sysGroupId: SYSTEM_GROUP.plaster.id,
    id: 70,
    baseSystemId: 48,
    name: "MP 75 L STROJNA ČISTA GIPSANA ŽBUKA",
    calculationDescription: "MP 75 L strojna čista gipsana žbuka",
    tooltip: "Lagana strojna čista gipsana žbuka.",
    group: "MP 75 L STROJNA ČISTA GIPSANA ŽBUKA",
    class: homeCSS.unassignedSubSystem,
    imageSource: "",
  },
];

export const SYSTEM_DATA = [
  {
    typeId: SYSTEM_GROUP.wall.id,
    name: "Sustavi Zidova",
    rooms: [
      {
        name: ROOM_TYPES.BATHROOM_MID,
        systems: [
          {
            id: 4,
            baseSystemId: 2,
            name: "W112 H2+A13",
            calculationDescription: "W112 H2 i A13 pregradni zid",
            group: "W112",
            class: homeCSS.bathroomMidWall,
            imageSource: bathroomMidWallImg,
          },
        ],
        class: homeCSS.bathroomMid,
        imageSource: bathromMidImg,
        videoSource: bathroomMidVideo,
        roomSelect: true,
      },
      {
        name: ROOM_TYPES.BASEMENT,
        systems: [
          {
            id: 7,
            baseSystemId: 3,
            name: "W112 DF 13 EI90",
            calculationDescription: "W112 DF 13 EI90 pregradni zid",
            group: "W112",
            class: homeCSS.basementWall,
            imageSource: basementWallImg,
          },
        ],

        class: homeCSS.basement,
        imageSource: basementImg,
        videoSource: basementVideo,
        roomSelect: true,
      },
      {
        name: ROOM_TYPES.BATHROOM_UP,
        systems: [
          {
            id: 17,
            baseSystemId: 7,
            name: "W113 EI90",
            calculationDescription: "W113 EI90 pregradni zid",
            group: "W113",
            class: homeCSS.bathroomUpWallThree,
            imageSource: bathroomUpWallThreeImg,
          },
        ],

        class: homeCSS.bathroomUp,
        imageSource: bathroomUpImg,
        videoSource: bathroomUpVideo,
        roomSelect: true,
      },
      {
        name: ROOM_TYPES.BEDROOM,
        systems: [
          {
            id: 1,
            baseSystemId: 1,
            name: "W112 A13 EI60",
            calculationDescription: "W112 A13 EI60 pregradni zid",
            group: "W112",
            class: homeCSS.bedroomWall,
            imageSource: bedroomWallImg,
          },
        ],

        class: homeCSS.bedroom,
        imageSource: bedroomImg,
        videoSource: bedroomVideo,
        roomSelect: true,
      },
      {
        name: ROOM_TYPES.HALLWAY_MID,
        systems: [
          {
            id: 10,
            baseSystemId: 4,
            name: "W112 H2 13 EI60",
            calculationDescription: "W112 H2 13 EI60 pregradni zid",
            group: "W112",
            class: homeCSS.hallwayMidWall,
            imageSource: hallwayMidWallImg,
          },
        ],

        class: homeCSS.hallwayMid,
        imageSource: hallwayMidImg,
        videoSource: hallwayMidVideo,
        roomSelect: true,
      },
      {
        name: ROOM_TYPES.KITCHEN,
        systems: [
          {
            id: 13,
            baseSystemId: 5,
            name: "W112 DIAMANT EI90",
            calculationDescription: "W112 DIAMANT EI90 pregradni zid",
            group: "W112",
            class: homeCSS.kitchenWall,
            imageSource: kitchenWallImg,
          },
        ],

        class: homeCSS.kitchen,
        imageSource: kitchenImg,
        videoSource: kitchenVideo,
        roomSelect: true,
      },
      {
        name: ROOM_TYPES.MUSIC_ROOM,
        systems: [
          {
            id: 16,
            baseSystemId: 6,
            name: "W112 SILENTBOARD",
            calculationDescription: "W112 SILENTBOARD pregradni zid",
            group: "W112",
            class: homeCSS.musicRoomWall,
            imageSource: musicRoomWallImg,
          },
        ],

        class: homeCSS.musicRoom,
        imageSource: musicRoomImg,
        videoSource: musicRoomVideo,
        roomSelect: true,
      },
      {
        name: ROOM_TYPES.OFFICE,
        systems: [
          {
            id: 17,
            baseSystemId: 7,
            name: "W113 EI90",
            calculationDescription: "W113 EI90 pregradni zid",
            group: "W113",
            class: homeCSS.officeWall,
            imageSource: officeWallImg,
          },
        ],

        class: homeCSS.office,
        imageSource: officeImg,
        videoSource: officeVideo,
        roomSelect: true,
      },
      {
        name: ROOM_TYPES.ORDINACIJA,
        systems: [
          {
            id: 24,
            baseSystemId: 12,
            name: "SAFEBOARD 12,5 cm 1+1",
            group: "W112",
            calculationDescription: "W112 SAFEBOARD 1x12,5 mm, DIAMANT 1x12,5 mm",
            class: homeCSS.ordinacijaWallOne,
            imageSource: ordinacijaWallOneImg,
          },
        ],

        class: homeCSS.ordinacija,
        imageSource: ordinacijaImg,
        videoSource: ordinacijaVideo,
        roomSelect: true,
      },
    ],
    class: homeCSS.wall,
    unassignedSystems: [
      {
        id: 20,
        baseSystemId: 8,
        name: "W115 EI90",
        calculationDescription: "W115  EI90 pregradni zid (Rw 65 dB)",
        class: homeCSS.unassignedSubSystem,
        imageSource: "",
      },
      { id: 21, baseSystemId: 9, name: "W116", calculationDescription: "W116 pregradni zid (Rw 54 dB)", class: homeCSS.unassignedSubSystem, imageSource: "" },
      {
        id: 22,
        baseSystemId: 10,
        name: "W118 RC3 PROTUPROVALNI ZID",
        calculationDescription: "W118 RC3 protuprovalni zid (Rw 65 dB)",
        class: homeCSS.unassignedSubSystem,
        imageSource: "",
      },
      {
        id: 23,
        baseSystemId: 11,
        name: "K131 Pb 1 mm",
        calculationDescription: "K 131 Pb 1 mm pregradni zid za zaštitu od zračenja",
        class: homeCSS.unassignedSubSystem,
        imageSource: "",
      },
      { id: 25, baseSystemId: 13, name: "W131", calculationDescription: "W131 EI-M 90 pregradni zid", class: homeCSS.unassignedSubSystem, imageSource: "" },
    ],
    unassignedSubSysClass: homeCSS.unassignedSubSysTop,
    imageSource: "",
    videoSource: "",
    roomSelect: false,
  },
  {
    typeId: SYSTEM_GROUP.wall_cover.id,
    name: "Sustavi Zidnih Obloga i Šahti",
    rooms: [
      {
        name: ROOM_TYPES.HALLWAY_UP,
        systems: [
          {
            id: 36,
            baseSystemId: 20,
            name: "W628 TIP B EI90",
            calculationDescription: "W628 tip B EI90 pregrade za šahte",
            group: "W628",
            class: homeCSS.hallwayUpWall,
            imageSource: hallwayUpWallImg,
          },
        ],
        class: homeCSS.hallwayUp,
        imageSource: hallwayUpImg,
        videoSource: hallwayUpVideo,
        roomSelect: true,
      },
      {
        name: ROOM_TYPES.LIVING_ROOM,
        systems: [
          {
            id: 28,
            baseSystemId: 15,
            name: "W623 OBLOGA CD PROFILI",
            calculationDescription: "W623 zidna obloga CD profili",
            group: "W623",
            class: homeCSS.livingRoomWall,
            imageSource: livingRoomWallImg,
          },
        ],
        class: homeCSS.livingRoom,
        imageSource: livingRoomImg,
        videoSource: livingRoomVideo,
        roomSelect: true,
      },
      {
        name: ROOM_TYPES.ORDINACIJA,
        systems: [
          {
            id: 34,
            baseSystemId: 18,
            name: "W626 DIAMANT 2x12,5",
            calculationDescription: "W626 DIAMANT ploča DFH2IR 2x12,5 zidna obloga",
            group: "W626",
            class: homeCSS.ordinacijaWallTwo,
            imageSource: ordinacijaWallTwoImg,
          },
        ],
        class: homeCSS.ordinacija,
        imageSource: ordinacijaImg,
        videoSource: ordinacijaVideo,
        roomSelect: true,
      },
      {
        name: ROOM_TYPES.ORDINACIJA_OFFICE,
        systems: [
          {
            id: 37,
            baseSystemId: 21,
            name: "W629 CLEANEO OBLOGA CW PROFILI",
            calculationDescription: "W629 Cleaneo zidna obloga s dvostrukim CW profilima",
            group: "W629",
            class: homeCSS.ordinacijaOfficeWall,
            imageSource: ordinacijaOfficeWallImg,
          },
        ],
        class: homeCSS.ordinacijaOffice,
        imageSource: ordinacijaOfficeImg,
        videoSource: ordinacijaOfficeVideo,
        roomSelect: true,
      },
    ],
    class: homeCSS.wallCover,
    unassignedSystems: [
      {
        id: 30,
        baseSystemId: 16,
        name: "W625",
        calculationDescription: "W625 zidna obloga bez protupožarnih zahtjeva",
        class: homeCSS.unassignedSubSystem,
        imageSource: "",
      },
      {
        id: 32,
        baseSystemId: 17,
        name: "W626 A13,H213",
        calculationDescription: "W 626 zidna obloga bez protupožarnih zahtjeva",
        class: homeCSS.unassignedSubSystem,
        imageSource: "",
      },
      {
        id: 35,
        baseSystemId: 19,
        name: "W628 tip B EI60",
        calculationDescription: "W628 tip B EI60 pregrada za šahte",
        class: homeCSS.unassignedSubSystem,
        imageSource: "",
      },
      { id: 26, baseSystemId: 14, name: "W611 SUHA ŽBUKA", calculationDescription: "W611 suha žbuka", class: homeCSS.unassignedSubSystem, imageSource: "" },
      {
        id: 38,
        baseSystemId: 22,
        name: "K151 Pb 1 mm",
        calculationDescription: "K151 zidna obloga s olovom za zaštitu od zračenja",
        class: homeCSS.unassignedSubSystem,
        imageSource: "",
      },
    ],
    unassignedSubSysClass: homeCSS.unassignedSubSysTop,
    imageSource: "",
    videoSource: "",
    roomSelect: true,
  },
  {
    typeId: SYSTEM_GROUP.suspended_ceiling.id,
    name: "Sustavi Spuštenih Stropova",
    rooms: [
      {
        name: ROOM_TYPES.KIDS_ROOM,
        systems: [
          {
            id: 40,
            baseSystemId: 23,
            name: "D112 A13",
            calculationDescription: "D112 A13 spušteni strop bez protupožarnih zahtjeva",
            group: "D112",
            class: homeCSS.kidsRoomCeiling,
            imageSource: kidsRoomCeilingImg,
          },
        ],
        class: homeCSS.kidsRoom,
        imageSource: kidsRoomImg,
        videoSource: kidsRoomVideo,
        roomSelect: true,
      },
      {
        name: ROOM_TYPES.BATHROOM_UP,
        systems: [
          {
            id: 41,
            baseSystemId: 24,
            name: "D112 H2 13",
            calculationDescription: "D112 H2 13 spušteni strop bez protupožarnih zahtjeva",
            group: "D112",
            class: homeCSS.bathroomUpCeiling,
            imageSource: bathroomUpCeilingImg,
          },
        ],
        class: homeCSS.bathroomUp,
        imageSource: bathroomUpImg,
        videoSource: bathroomUpVideo,
        roomSelect: true,
      },
      {
        name: ROOM_TYPES.ATTIC,
        systems: [
          {
            id: 42,
            baseSystemId: 25,
            name: "D112 2xDF 15 EI60",
            calculationDescription: "D112 2 x DF 15 EI60 protupožarni spušteni strop odozdo",
            group: "D112",
            class: homeCSS.atticCeilingOne,
            imageSource: atticCeilingOneImg,
          },
          {
            id: 49,
            baseSystemId: 32,
            name: "D612 2x15 DF REI60",
            calculationDescription: "D612 2x15 DF RE/REI60 protupožarna obloga krovnih kosina",
            group: "D612",
            class: homeCSS.atticCeilingTwo,
            imageSource: atticCeilingTwoImg,
          },
        ],
        class: homeCSS.attic,
        imageSource: atticImg,
        videoSource: atticVideo,
        roomSelect: true,
      },
      {
        name: ROOM_TYPES.KITCHEN,
        systems: [
          {
            id: 45,
            baseSystemId: 28,
            name: "D112 2x20 MBP EI90",
            calculationDescription: "D112 2x20 MPB EI90 protupožarni spušteni strop odozdo",
            group: "D112",
            class: homeCSS.kitchenCeiling,
            imageSource: kitchenCeilingImg,
          },
        ],
        class: homeCSS.kitchen,
        imageSource: kitchenImg,
        videoSource: kitchenVideo,
        roomSelect: true,
      },
      {
        name: ROOM_TYPES.ORDINACIJA_OFFICE,
        systems: [
          {
            id: 47,
            baseSystemId: 30,
            name: "D127 Cleaneo",
            calculationDescription: "D127 Cleaneo akustični spušteni strop bez protupožarnih zahtjeva s udjelom perforacije 23%",
            group: "D127",
            class: homeCSS.ordinacijaOfficeCeiling,
            imageSource: ordinacijaOfficeCeilingImg,
          },
        ],
        class: homeCSS.ordinacijaOffice,
        imageSource: ordinacijaOfficeImg,
        videoSource: ordinacijaOfficeVideo,
        roomSelect: true,
      },
    ],
    class: homeCSS.suspendedCeiling,
    unassignedSystems: [
      {
        id: 43,
        baseSystemId: 26,
        name: "D113 2x12,5",
        calculationDescription: "D113 2x12,5 spušteni strop bez protupožarnih zahtjeva, konstrukcija u nivou",
        class: homeCSS.unassignedSubSystem,
        imageSource: "",
      },
      {
        id: 44,
        baseSystemId: 27,
        name: "D112 3x15 DF EI90",
        calculationDescription: "D112 3x15 DF EI90 protupožarni spušteni strop odozdo",
        class: homeCSS.unassignedSubSystem,
        imageSource: "",
      },
      {
        id: 46,
        baseSystemId: 29,
        name: "D116 EI90",
        calculationDescription: "D116 EI90 protupožarni spušteni strop",
        class: homeCSS.unassignedSubSystem,
        imageSource: "",
      },
      {
        id: 48,
        baseSystemId: 31,
        name: "D112 L",
        calculationDescription: "D112L 1xA13L 12,5 mm spušteni strop bez protupožarnih zahtjeva",
        class: homeCSS.unassignedSubSystem,
        imageSource: "",
      },
      {
        id: 50,
        baseSystemId: 33,
        name: "D112 DIAMANT 2x12,5 mm EI30",
        calculationDescription: "D112 DIAMANT ploča 2x12,5 EI30 protupožarni spušteni strop",
        class: homeCSS.unassignedSubSystem,
        imageSource: "",
      },
      {
        id: 51,
        baseSystemId: 34,
        name: "K219 EI90 O-O",
        calculationDescription: "K219 EI90 samonosivi protupožarni strop odozdo i odozgo za raspon prostorije maks. 325 cm",
        class: homeCSS.unassignedSubSystem,
        imageSource: "",
      },
      {
        id: 52,
        baseSystemId: 35,
        name: "K217 REI 90 2x20 FB A1",
        calculationDescription: "K217 REI90 2x20 FB A1 spuštanje do 12 cm direktni ovjes, protupožarni spušteni strop",
        class: homeCSS.unassignedSubSystem,
        imageSource: "",
      },
    ],
    unassignedSubSysClass: homeCSS.unassignedSubSysSide,
    imageSource: "",
    videoSource: "",
    roomSelect: false,
  },
  {
    typeId: SYSTEM_GROUP.fire_protection.id,
    name: "Posebni Protupožarni Sustavi",
    rooms: [
      {
        name: ROOM_TYPES.KIDS_ROOM,
        systems: [
          { id: 53, baseSystemId: 36, group: "K 252", calculationDescription: "K 252 FIREBOARD ploča A1 R 120 obloga čeličnih greda", class: homeCSS.hide },
          { id: 54, baseSystemId: 37, group: "W227 EI90", calculationDescription: "W227 EI90 obloga parapeta fasade 100 cm visine", class: homeCSS.hide },
        ],
        class: homeCSS.kidsRoom,
        imageSource: kidsRoomImg,
        videoSource: kidsRoomVideo,
        roomSelect: false,
      },
    ],
    class: homeCSS.fireProtection,
    unassignedSystems: [
      {
        id: 53,
        baseSystemId: 36,
        name: "K 252",
        calculationDescription: "K 252 FIREBOARD ploča A1 R 120 obloga čeličnih greda",
        class: homeCSS.unassignedSubSystem,
        imageSource: "",
      },
      {
        id: 54,
        baseSystemId: 37,
        name: "W227 EI90",
        calculationDescription: "W227 EI90 obloga parapeta fasade 100 cm visine",
        class: homeCSS.unassignedSubSystem,
        imageSource: "",
      },
    ],
    unassignedSubSysClass: homeCSS.unassignedSubSysTop,
    imageSource: "",
    videoSource: "",
    roomSelect: false,
  },
  {
    typeId: SYSTEM_GROUP.aquapanel.id,
    name: "Aquapanel Sustavi",
    rooms: [
      {
        name: ROOM_TYPES.OUTSIDE,
        systems: [
          {
            id: 55,
            baseSystemId: 38,
            name: "AQUAPANEL OUTDOOR SPUŠTENI STROP",
            calculationDescription: "AQUAPANEL Outdoor spušteni strop s antikorozivnom zaštitom",
            group: "AQP OUTDOOR",
            class: homeCSS.outsideCeiling,
            imageSource: outsideCeilingImg,
          },
        ],
        class: homeCSS.outside,
        imageSource: outsideImg,
        videoSource: outsideVideo,
        roomSelect: true,
      },
      {
        name: ROOM_TYPES.BATHROOM_UP,
        systems: [
          {
            id: 59,
            baseSystemId: 41,
            name: "AQUAPANEL INDOOR OBLOGA 2x12,5 mm",
            calculationDescription: "AQUAPANEL Indoor zidna obloga 17,5 cm s antikorozivnom zaštitom",
            group: "Indoor Obloga",
            class: homeCSS.bathroomUpWallOne,
            imageSource: bathroomUpWallOneImg,
          },
          {
            id: 58,
            baseSystemId: 40,
            name: "AQUAPANEL INDOOR ZID",
            calculationDescription: "AQUAPANEL Indoor pregradni zid 12,5 cm s antikorozivnom zaštitom",
            group: "Zid",
            class: homeCSS.bathroomUpWallTwo,
            imageSource: bathroomUpWallTwoImg,
          },
        ],
        class: homeCSS.bathroomUp,
        imageSource: bathroomUpImg,
        videoSource: bathroomUpVideo,
        roomSelect: true,
      },
    ],
    class: homeCSS.aquapanel,
    unassignedSystems: [
      {
        id: 57,
        baseSystemId: 39,
        name: "AQUAPANEL SKY LITE SPUŠTENI STROP",
        calculationDescription: "AQUAPANEL Sky Lite spušteni strop s antikorozivnom zaštitom",
        class: homeCSS.unassignedSubSystem,
        imageSource: "",
      },
    ],
    unassignedSubSysClass: homeCSS.unassignedSubSysSide,
    imageSource: "",
    videoSource: "",
    roomSelect: false,
  },
  {
    typeId: SYSTEM_GROUP.floor.id,
    name: "Podni Sustavi",
    rooms: [
      {
        name: ROOM_TYPES.OFFICE,
        systems: [
          {
            id: 60,
            baseSystemId: 42,
            name: "F145",
            calculationDescription: "F145 suhi estrih",
            group: "F145",
            class: homeCSS.officeFloor,
            imageSource: officeFloorImg,
          },
        ],
        class: homeCSS.office,
        imageSource: officeImg,
        videoSource: officeVideo,
        roomSelect: true,
      },
      {
        name: ROOM_TYPES.ATTIC,
        systems: [
          {
            id: 62,
            baseSystemId: 44,
            name: "F191",
            calculationDescription: "F191 uzdignuti 'plivajući' pod na drvenim, čeličnim konstrukcijama",
            group: "F191",
            class: homeCSS.atticFloor,
            imageSource: atticFloorImg,
          },
        ],
        class: homeCSS.attic,
        imageSource: atticImg,
        videoSource: atticVideo,
        roomSelect: true,
      },
    ],
    class: homeCSS.floor,
    unassignedSystems: [
      {
        id: 61,
        baseSystemId: 43,
        name: "F181",
        calculationDescription: "F181 uzdignuti pod na metalnim nožicama različitih visina",
        class: homeCSS.unassignedSubSystem,
        imageSource: "",
      },
    ],
    unassignedSubSysClass: homeCSS.unassignedSubSysTop,
    imageSource: "",
    videoSource: "",
    roomSelect: false,
  },
  {
    typeId: SYSTEM_GROUP.facade.id,
    name: "Fasadni Sustavi",
    rooms: [
      {
        name: ROOM_TYPES.OUTSIDE_RIGHT,
        systems: [
          {
            id: 68,
            baseSystemId: 47,
            name: "WARM WAND MW, EPS / MINERALNA KAMENA VUNA, STIROPOR",
            calculationDescription: "KFS WARM WAND MW EPS fasadni sustav s mineralnom kamenom vunom i stiroporom",
            group: "WARM WAND MW",
            class: homeCSS.outsideRightWall,
            imageSource: outsideRightWallImg,
          },
        ],
        class: homeCSS.outsideRight,
        imageSource: outsideRightImg,
        videoSource: outsideRightVideo,
        roomSelect: true,
      },
    ],
    class: homeCSS.facade,
    unassignedSystems: [
      {
        id: 63,
        baseSystemId: 45,
        name: "MW / MINERALNA KAMENA VUNA",
        calculationDescription: "KFS MW fasadni sustav s mineralnom kamenom vunom",
        class: homeCSS.unassignedSubSystem,
        imageSource: "",
      },
      {
        id: 66,
        baseSystemId: 46,
        name: "EPS / STIROPOR",
        calculationDescription: "KFS EPS fasadni sustav sa stiroporom",
        class: homeCSS.unassignedSubSystem,
        imageSource: "",
      },
    ],
    unassignedSubSysClass: homeCSS.unassignedSubSysTop,
    imageSource: "",
    videoSource: "",
    roomSelect: false,
  },
];

export const ROOM_DATA = [
  { name: ROOM_TYPES.INTRO, systems: [], class: "", imageSource: introImg, videoSource: "", roomSelect: false },
  {
    name: ROOM_TYPES.STARTING,
    systems: [],
    class: "",
    imageSource: startingImg,
    videoSource: startingVideo,
    reverseVideoSource: startingVideoReverse,
    roomSelect: false,
  },
  {
    name: ROOM_TYPES.ATTIC,
    systems: [
      { id: 62, baseSystemId: 44, name: "F191", class: homeCSS.atticFloor, imageSource: atticFloorImg },
      {
        id: 42,
        baseSystemId: 25,
        name: "D112 2xDF 15 EI60",
        calculationDescription: "D112 2 x DF 15 EI60 protupožarni spušteni strop odozdo",
        class: homeCSS.atticCeilingOne,
        imageSource: atticCeilingOneImg,
      },
      {
        id: 49,
        baseSystemId: 32,
        name: "D612 2x15 DF REI60",
        calculationDescription: "D612 2x15 DF RE/REI60 protupožarna obloga krovnih kosina",
        class: homeCSS.atticCeilingTwo,
        imageSource: atticCeilingTwoImg,
      },
    ],
    class: homeCSS.attic,
    imageSource: atticImg,
    videoSource: atticVideo,
    reverseVideoSource: atticVideoReverse,
    roomSelect: true,
  },
  {
    name: ROOM_TYPES.BASEMENT,
    systems: [
      {
        id: 7,
        baseSystemId: 3,
        name: "W112 DF 13 EI90",
        calculationDescription: "W112 DF 13 EI90 pregradni zid",
        class: homeCSS.basementWall,
        imageSource: basementWallImg,
      },
    ],
    class: homeCSS.basement,
    imageSource: basementImg,
    videoSource: basementVideo,
    reverseVideoSource: basementVideoReverse,
    roomSelect: true,
  },
  {
    name: ROOM_TYPES.BATHROOM_MID,
    systems: [
      {
        id: 4,
        baseSystemId: 2,
        name: "W112 H2+A13",
        calculationDescription: "W112 H2 i A13 pregradni zid",
        class: homeCSS.bathroomMidWall,
        imageSource: bathroomMidWallImg,
      },
    ],
    class: homeCSS.bathroomMid,
    imageSource: bathromMidImg,
    videoSource: bathroomMidVideo,
    reverseVideoSource: bathroomMidVideoReverse,
    roomSelect: true,
  },
  {
    name: ROOM_TYPES.BATHROOM_UP,
    systems: [
      {
        id: 59,
        baseSystemId: 41,
        name: "AQUAPANEL INDOOR OBLOGA 2x12,5 mm",
        calculationDescription: "AQUAPANEL Indoor zidna obloga 17,5 cm s antikorozivnom zaštitom",
        class: homeCSS.bathroomUpWallOne,
        imageSource: bathroomUpWallOneImg,
      },
      {
        id: 58,
        baseSystemId: 40,
        name: "AQUAPANEL INDOOR ZID",
        calculationDescription: "AQUAPANEL Indoor pregradni zid 12,5 cm s antikorozivnom zaštitom",
        class: homeCSS.bathroomUpWallTwo,
        imageSource: bathroomUpWallTwoImg,
      },
      {
        id: 17,
        baseSystemId: 7,
        name: "W113 EI90",
        calculationDescription: "W113 EI90 pregradni zid",
        class: homeCSS.bathroomUpWallThree,
        imageSource: bathroomUpWallThreeImg,
      },
      {
        id: 41,
        baseSystemId: 24,
        name: "D112 H2 13",
        calculationDescription: "D112 H2 13 spušteni strop bez protupožarnih zahtjeva",
        class: homeCSS.bathroomUpCeiling,
        imageSource: bathroomUpCeilingImg,
      },
    ],
    class: homeCSS.bathroomUp,
    imageSource: bathroomUpImg,
    videoSource: bathroomUpVideo,
    reverseVideoSource: bathroomUpVideoReverse,
    roomSelect: true,
  },
  {
    name: ROOM_TYPES.BEDROOM,
    systems: [
      {
        id: 1,
        baseSystemId: 1,
        name: "W112 A13 EI60",
        calculationDescription: "W112 A13 EI60 pregradni zid",
        class: homeCSS.bedroomWall,
        imageSource: bedroomWallImg,
      },
    ],
    class: homeCSS.bedroom,
    imageSource: bedroomImg,
    videoSource: bedroomVideo,
    reverseVideoSource: bedroomVideoReverse,
    roomSelect: true,
  },
  {
    name: ROOM_TYPES.HALLWAY_MID,
    systems: [
      {
        id: 10,
        baseSystemId: 4,
        name: "W112 H2 13 EI60",
        calculationDescription: "W112 H2 13 EI60 pregradni zid",
        class: homeCSS.hallwayMidWall,
        imageSource: hallwayMidWallImg,
      },
    ],
    class: homeCSS.hallwayMid,
    imageSource: hallwayMidImg,
    videoSource: hallwayMidVideo,
    reverseVideoSource: hallwayMidVideoReverse,
    roomSelect: true,
  },
  {
    name: ROOM_TYPES.HALLWAY_UP,
    systems: [
      {
        id: 36,
        baseSystemId: 20,
        name: "W628 TIP B EI90",
        calculationDescription: "W628 tip B EI90 pregrade za šahte",
        class: homeCSS.hallwayUpWall,
        imageSource: hallwayUpWallImg,
      },
    ],
    class: homeCSS.hallwayUp,
    imageSource: hallwayUpImg,
    videoSource: hallwayUpVideo,
    reverseVideoSource: hallwayUpVideoReverse,
    roomSelect: true,
  },
  {
    name: ROOM_TYPES.KIDS_ROOM,
    systems: [
      {
        id: 40,
        baseSystemId: 23,
        name: "D112 A13",
        calculationDescription: "D112 A13 spušteni strop bez protupožarnih zahtjeva",
        class: homeCSS.kidsRoomCeiling,
        imageSource: kidsRoomCeilingImg,
      },
    ],
    class: homeCSS.kidsRoom,
    imageSource: kidsRoomImg,
    videoSource: kidsRoomVideo,
    reverseVideoSource: kidsRoomVideoReverse,
    roomSelect: true,
  },
  {
    name: ROOM_TYPES.KITCHEN,
    systems: [
      {
        id: 45,
        baseSystemId: 28,
        name: "D112 2x20 MBP EI90",
        calculationDescription: "D112 2x20 MPB EI90 protupožarni spušteni strop odozdo",
        class: homeCSS.kitchenCeiling,
        imageSource: kitchenCeilingImg,
      },
      {
        id: 13,
        baseSystemId: 5,
        name: "W112 DIAMANT EI90",
        calculationDescription: "W112 DIAMANT EI90 pregradni zid",
        class: homeCSS.kitchenWall,
        imageSource: kitchenWallImg,
      },
    ],
    class: homeCSS.kitchen,
    imageSource: kitchenImg,
    videoSource: kitchenVideo,
    reverseVideoSource: kitchenVideoReverse,
    roomSelect: true,
  },
  {
    name: ROOM_TYPES.LIVING_ROOM,
    systems: [
      {
        id: 28,
        baseSystemId: 15,
        name: "W623 OBLOGA CD PROFILI",
        calculationDescription: "W623 zidna obloga CD profili",
        class: homeCSS.livingRoomWall,
        imageSource: livingRoomWallImg,
      },
    ],
    class: homeCSS.livingRoom,
    imageSource: livingRoomImg,
    videoSource: livingRoomVideo,
    reverseVideoSource: livingRoomVideoReverse,
    roomSelect: true,
  },
  {
    name: ROOM_TYPES.MUSIC_ROOM,
    systems: [
      {
        id: 16,
        baseSystemId: 6,
        name: "W112 SILENTBOARD",
        calculationDescription: "W112 SILENTBOARD pregradni zid",
        class: homeCSS.musicRoomWall,
        imageSource: musicRoomWallImg,
      },
    ],
    class: homeCSS.musicRoom,
    imageSource: musicRoomImg,
    videoSource: musicRoomVideo,
    reverseVideoSource: musicRoomVideoReverse,
    roomSelect: true,
  },
  {
    name: ROOM_TYPES.OFFICE,
    systems: [
      { id: 60, baseSystemId: 42, name: "F145", calculationDescription: "F145 suhi estrih", class: homeCSS.officeFloor, imageSource: officeFloorImg },
      { id: 17, baseSystemId: 7, name: "W113 EI90", calculationDescription: "W113 EI90 pregradni zid", class: homeCSS.officeWall, imageSource: officeWallImg },
    ],
    class: homeCSS.office,
    imageSource: officeImg,
    videoSource: officeVideo,
    reverseVideoSource: officeVideoReverse,
    roomSelect: true,
  },
  {
    name: ROOM_TYPES.ORDINACIJA,
    systems: [
      {
        id: 24,
        baseSystemId: 12,
        name: "SAFEBOARD 12,5 cm 1+1",
        calculationDescription: "W112 SAFEBOARD 1x12,5 mm, DIAMANT 1x12,5 mm",
        class: homeCSS.ordinacijaWallOne,
        imageSource: ordinacijaWallOneImg,
      },
      {
        id: 34,
        baseSystemId: 18,
        name: "W626 DIAMANT 2x12,5",
        calculationDescription: "W626 DIAMANT ploča DFH2IR 2x12,5 zidna obloga",
        class: homeCSS.ordinacijaWallTwo,
        imageSource: ordinacijaWallTwoImg,
      },
    ],
    class: homeCSS.ordinacija,
    imageSource: ordinacijaImg,
    videoSource: ordinacijaVideo,
    reverseVideoSource: ordinacijaVideoReverse,
    roomSelect: true,
  },
  {
    name: ROOM_TYPES.ORDINACIJA_OFFICE,
    systems: [
      {
        id: 47,
        baseSystemId: 30,
        name: "D127 Cleaneo",
        calculationDescription: "D127 Cleaneo akustični spušteni strop bez protupožarnih zahtjeva s udjelom perforacije 23%",
        class: homeCSS.ordinacijaOfficeCeiling,
        imageSource: ordinacijaOfficeCeilingImg,
      },
      {
        id: 37,
        baseSystemId: 21,
        name: "W629 CLEANEO OBLOGA CW PROFILI",
        calculationDescription: "W629 Cleaneo zidna obloga s dvostrukim CW profilima",
        class: homeCSS.ordinacijaOfficeWall,
        imageSource: ordinacijaOfficeWallImg,
      },
    ],
    class: homeCSS.ordinacijaOffice,
    imageSource: ordinacijaOfficeImg,
    videoSource: ordinacijaOfficeVideo,
    reverseVideoSource: ordinacijaOfficeVideoReverse,
    roomSelect: true,
  },
  {
    name: ROOM_TYPES.OUTSIDE,
    systems: [
      {
        id: 55,
        baseSystemId: 38,
        name: "AQUAPANEL OUTDOOR SPUŠTENI STROP",
        calculationDescription: "AQUAPANEL Outdoor spušteni strop s antikorozivnom zaštitom",
        class: homeCSS.outsideCeiling,
        imageSource: outsideCeilingImg,
      },
    ],
    class: homeCSS.outside,
    imageSource: outsideImg,
    videoSource: outsideVideo,
    reverseVideoSource: outsideVideoReverse,
    roomSelect: true,
  },
  {
    name: ROOM_TYPES.OUTSIDE_RIGHT,
    systems: [
      {
        id: 68,
        baseSystemId: 47,
        name: "WARM WAND MW, EPS / MINERALNA KAMENA VUNA, STIROPOR",
        calculationDescription: "KFS WARM WAND MW EPS fasadni sustav s mineralnom kamenom vunom i stiroporom",
        class: homeCSS.outsideRightWall,
        imageSource: outsideRightWallImg,
      },
    ],
    class: homeCSS.outsideRight,
    imageSource: outsideRightImg,
    videoSource: outsideRightVideo,
    reverseVideoSource: outsideRightVideoReverse,
    roomSelect: true,
  },
  {
    name: ROOM_TYPES.WAITING_ROOM_STUDIO,
    systems: [{ id: 62, baseSystemId: 44, name: "F191", class: homeCSS.atticFloor, imageSource: atticFloorImg }],
    class: homeCSS.waitingRoomStudio,
    imageSource: waitingRoomStudioImg,
    videoSource: waitingRoomStudioVideo,
    reverseVideoSource: waitingRoomStudioVideoReverse,
    roomSelect: true,
  },
  {
    name: ROOM_TYPES.WAITING_ROOM,
    systems: [{ id: 62, baseSystemId: 44, name: "F191", class: homeCSS.atticFloor, imageSource: atticFloorImg }],
    class: homeCSS.waitingRoom,
    imageSource: waitingRoomImg,
    videoSource: waitingRoomVideo,
    reverseVideoSource: waitingRoomVideoReverse,
    roomSelect: true,
  },
];
